import { modifier } from 'ember-modifier';

export default modifier(function clickOutside(element: HTMLElement, [callback]: [(event: MouseEvent) => void]) {
  function handleClick(event: MouseEvent) {
    if (!element.contains(event.target as Node)) {
      callback(event);
    }
  }
  document.addEventListener('mousedown', handleClick, true);
  return () => {
    document.removeEventListener('mousedown', handleClick, true);
  };
});
